<script setup lang="ts">
const { playlist } = storeToRefs(useAudioStore())
</script>

<template>
  <section
    v-if="playlist?.length"
    class="relative flex size-full flex-col items-center justify-start overflow-hidden bg-darkest pt-16 md:mt-10 md:max-w-[70%] md:bg-darker"
  >
    <ol
      class="size-full overflow-y-auto p-8 pt-6 [mask-image:linear-gradient(to_bottom,black_calc(100%-8rem),transparent)] md:mt-20 md:pb-32 md:pl-0 md:pr-8"
    >
      <UAudioPlayerPlaylistItem
        v-for="track in playlist"
        :key="track.id"
        :track="track"
      />
    </ol>
  </section>
  <h2 v-else class="font-light text-white">
    Vi fant ingen lydspor dessverre. Ta gjerne kontakt med oss om du
    skulle ønske det fantes, eller om dette virker som en feil!
  </h2>
</template>
